<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary">
            تیم اجرایی
        </a-button>

        <a-modal width="1000px" v-model="visible" title=" تیم اجرایی سمینار" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>
            <form @submit.prevent="addData($event)">
                <input name="seminar_id" type="hidden" :value="seminar.id">

            <div class="row">
            <div class="col-md-3">
                    <div class="form-group text-right">
                        <label for=""> (ریال) مبلغ حقوق</label>
                        <input v-model="host.salary" name="salary" type="number" class="form-control">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group text-right">
                        <label for=""> میزان سود</label>
                        <input v-model="host.profit_percent" name="profit_percent" type="number" class="form-control">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group text-right">
                        <label class="sr-only" for="inline-form-input-name">
                            انتخاب نقش</label>
                        <a-select mode="single" style="width:100%" placeholder="انتخاب  نقش" v-model="host.seminar_role"
                            @change="defaulProfit()">
                            <a-select-option v-for="role in roles" :key="role.id" :value="role.id">
                                {{ role . title }}
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group text-right">
                        <UserSearch @ids="getIds" />

                    </div>
                </div>
                <div class="mt-1">
                    <button type="submit"  class="btn btn-fill btn-outline-success ">
                                        ذخیره
                                    </button>
                </div>


            </div>
            </form>
            <hr>
            <div>
                <table class="table ">
                    <thead>
                        <tr>
                            <th scope="col"> </th>
                            <th scope="col"> مبلغ حقوق</th>
                            <th scope="col">میزان سود </th>
                            <th scope="col"> نقش</th>
                            <th scope="col">کاربر </th>
                            <th scope="col">شناسه</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="host in seminar.hosts">
                            <td>
                                <!-- <a-button class="btn-outline-warning" icon="delete" type="link"
                                @click="deleteRow(host.id)"></a-button> -->
                            </td>
                            <td>
                                <b-badge variant="light" class="text-dark">{{ $root.number_format(host.salary) }}</b-badge>
                            </td>
                            <td>
                                <b-badge variant="light" class="text-dark">{{ host.profit_percent }} %</b-badge>
                            </td>
                            <td>
                                <b-badge variant="light" class="text-dark"> {{  host.role.title }}</b-badge>
                            </td>
                            <td>
                                <b-badge variant="light" class="text-dark">{{host.user ?  $root.full_name(host . user . firstname , host . user . lastname) : '' }}</b-badge>
                            </td>
                            <th scope="row">#{{ host . id }}</th>


                        </tr>
                    </tbody>
                </table>
            </div>

        </a-modal>
    </div>
</template>
<script>
    import UserSearch from "../../components/Blocks/UserSelectSingle.vue"

    export default {
        props: {
            seminar: Object,
        },
         components: {
            UserSearch
        },

        data() {
            return {
                loading: false,
                visible: false,
                seminar_role: undefined,
                users: [],
                roles: [],
                info: {},
                host:{
                    user_id:'',
                    seminar_role:'',
                    profit_percent:'',
                    salary:''
                }
            
            };
        },
        methods: {
            getIds(value) {
                this.host.user_id=value
            },
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                data.append('user_id',this.host.user_id)
                data.append('seminar_role_id',this.host.seminar_role)
                _this.$root.loading = true;
                axios
                    .post("/seminars/host", data)
                    .then(function(response) {
                        console.log(response)
                        _this.$root.loading = false;
                        _this.seminar.hosts.push(response.data.data)
                        console.log(response.data.data)
                        console.log(_this.seminar.hosts)
                        _this.host={};
                        _this.$toast.success(" تیم سمینار با موفقیت افزوده شد");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            deleteRow(id) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(`seminars/host/delete/${id}`)
                            .then(function(response) {
                                _this.seminar.hosts = _this.seminar.hosts.filter((e)=>e.id !== id )
                                _this.$toast.success("با موفقیت حذف شد.");

                            })
                            .catch(function(err) {
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
            showModal() {
                this.visible = true;
            },
            defaulProfit() {
                let choosedRole = this.roles.find(x => x.id == this.host.seminar_role);
                this.host.profit_percent = choosedRole.profit_percent;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
            },
        
            async getRoles() {
                let _this = this;
                let url = '/seminars/roles';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.roles = response.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            findRole(id){
                const role = this.roles.find(({ id }) => id == id);
                return role.title
            },
           
        },
        mounted() {
            this.getRoles()
        }
    };
</script>
